module.exports = __webpack_public_path__ + "static/media/mic_on.d4bdc992.svg";